export const defaultTitle = "Oops. You can't get there from here.";

export const defaultSubtitle = [
  "The LIO page you've requested cannot be accessed",
  'for one of the following reasons:',
];

export const defaultItems = [
  "It doesn't exist or has moved",
  "It's temporarily unavailable",
  "You don't have the proper permissions to view it",
];

export const defaultMaintenanceTitle = "Good things are coming. We'll be right back!";

export const defaultMaintenanceSubtitle = [
  "We're currently working dillegently to bring you the best quote experience in the industry",
  'Thanks for your patience and please check back soon!',
];
